export default "__VITE_ASSET__0dd75e1f__"